<template>
    <div v-if="loaded">
        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="form.unidades"
                        :validations="validations.unidadeExecutante"
                        label="Unidade executante"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeExecutanteId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="form.competencias"
                        :validations="validations.competencia"
                        label="Competência"
                        show-default-option
                        text-field="valor"
                        v-model="model.competenciaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="possuiAutorizadorAtivo">
                <rkm-col cols="5">
                    <rkm-form-select
                        :options="form.autorizadores"
                        :validations="validations.usuarioAutorizador"
                        label="Profissional autorizador"
                        show-default-option
                        text-field="nome"
                        v-model="model.usuarioAutorizadorCns"
                        value-field="cns"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="autorizadorCns"
                        disabled
                        label="CNS do profissional autorizador"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :value="codigoEmissor"
                        disabled
                        label="Código do emissor"
                    />
                </rkm-col>
            </rkm-row>

            <small
                class="text-danger d-block"
                v-else
            >
                Não existem autorizadores ativos cadastrados.
            </small>
        </rkm-form>
    </div>
</template>

<script>
// Mixins.
import { error, formats, repository, stringCase, data } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {

            return {
                unidadeExecutante: { required: true },
                competencia: { required: true },
                usuarioAutorizador: { required: this.possuiAutorizadorAtivo },
            }
        },
        possuiAutorizadorAtivo() {

            return this.loaded && this.form.autorizadores.length > 0
        },
        autorizadorCns() {

            if (!this.loaded || !this.model.usuarioAutorizadorCns) {

                return ''
            }

            return this.formatCns(this.model.usuarioAutorizadorCns)
        },
        codigoEmissor() {

            if (!this.loaded || !this.model.usuarioAutorizadorCns) {

                return ''
            }

            return this.form.autorizadores.find(a => a.cns === this.model.usuarioAutorizadorCns).codigoEmissor
        },
    },
    created() {

        this.repositories = {
            procedimento: this.getConectaSusRepository('apac.procedimento'),
        }
    },
    data: () => ({
        loaded: false,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.loaded = false

            this.repositories.procedimento.create({ origem: 'geracao' })
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.model.origem = 'geracao'
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.isNullOrEmptyString(this.codigoEmissor)) {
                        this.showValidationNotification(`O autorizador selecionado não possui Código do Emissor cadastrado.
                            Atualize o Cadastro > Autorizador e tente novamente`)

                        return
                    }

                    this.setLoading()

                    this.repositories.procedimento.store(this.camelObjectKeysToSnakeRecursive(this.model))
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [error, formats, repository, stringCase, data],
}
</script>
